<template>
    <div>
        <nav-header></nav-header>
        <div class="editcompany-form validate-form p-l-50 p-r-50 p-t-10 p-b-28" >
            <section>
                <div class="page-title">
                    <h2>Cadastrar Empresa</h2>
                </div>
                <hr/><br>
                <div class="wrap-form-fields" style="align: center">
                    <div class="input-container">
                        <label class="label-input">Nome:</label>
                        <input v-model="name" type="name" id="inputName" autocomplete="off" class="input-field" />
                    </div>
                    <br>
                    <div class="input-container">
                        <label class="label-input">CNPJ:</label>
                        <input v-model="cnpj" autocomplete="off" type="tel" id="inputCnpj" v-mask="'##.###.###/####-##'" class="input-field" />
                    </div>
                    <br>
                    <div class="wrap-form-fields" style="align: center">
                        <label class="label-input">Custo por Documento:</label>
                        <b-input-group prepend="R$">
                            <b-form-input v-model="costPerReq" type="text" v-on:keyup="formatMoney('costPerReq')" class="input-field"></b-form-input>
                        </b-input-group>
                    </div>
                    <br>
                    <div class="wrap-form-fields" style="align: center">
                        <label class="label-input">Custo por Assinatura Digital:</label>
                        <b-input-group prepend="R$">
                            <b-form-input v-model="costPerSign" type="text" v-on:keyup="formatMoney('costPerSign')" class="input-field"></b-form-input>
                        </b-input-group>
                    </div>
                    <br>
                    <div class="wrap-form-fields" style="align: center">
                        <label class="label-input">Limite em megabytes mensal:</label>
                        <b-input-group append="MB">
                            <b-form-input v-model="limitMB" type="number" class="input-field"></b-form-input>
                        </b-input-group>
                    </div>
                </div>
                <button class="btn btn-secondary" v-on:click="$router.push({name:'companyManagement'})" style="aling: left; margin-left: 10px">Cancelar</button>
                <button class="btn btn-primary" v-on:click="this.addCompany" style="aling: left">Confirmar</button>
            </section>
        </div>
        <user-profile-footer></user-profile-footer>
    </div>
</template>

<style scoped src="@/assets/css/util.css">
</style>

<style scoped>
    .footer {
        position: inherit !important;
    }
</style>

<script>
    import axios from 'axios';
    import config from '../helpers/generalConfig';
    import NavHeader from "../components/NavHeader.vue";
    import UserProfileFooter from '../components/UserProfileFooter.vue';
    import {mask} from 'vue-the-mask'

    export default {
        components: { NavHeader, UserProfileFooter },

        directives: { mask },

        data() {
            return {
                name: '',
                cnpj: '',
                costPerReq: '',
                costPerSign: '',
                limitMB: '0'
            }
        },

        methods: {
            addCompany() {
                if(!this.name){
                    this.$bvToast.toast('Informe um nome válido.', {
                    title: 'Nome inválido',
                    variant: 'danger',
                    solid: true
                    });
                    return;
                }
                if(!this.cnpj){
                    this.$bvToast.toast('Informe um CNPJ válido.', {
                    title: 'CNPJ inválido',
                    variant: 'danger',
                    solid: true
                    });
                    return;
                }
                if(!this.costPerReq){
                    this.costPerReq = '0,00';
                    this.$root.$bvToast.toast('O custo foi definido como R$0,00 por padrão', {
                        title: 'Custo não informado',
                        variant: 'warning',
                        solid: true
                    });
                }
                if (!this.costPerSign) {
                    this.costPerSign = '0,00';
                    this.$root$bvToast.toast('O custo por assinatura digital foi definido como R$0,00 por padrão', {
                        title: 'Custo por assinatura digital não informado',
                        variant: 'warning',
                        solid: true
                    });
                }
                axios
                    .post(`${config.jsonServer}/company/addCompany`, {
                        nome_empresa: this.name,
                        cnpj_empresa: this.unmask(this.cnpj),
                        custo_requisicao: this.costPerReq.replace('.', '').replace(',', '.'),
                        custo_assinatura: this.costPerSign.replace('.', '').replace(',', '.'),
                        limite_tamanho: this.limitMB || '0',
                    }, this.headers())
                    .then(response => {
                        const company = response.data;
                        if(company){
                            this.name = '';
                            this.cnpj = '';
                            this.costPerReq = '';
                            this.costPerSign = '';
                            this.limitMB = '0';
                            this.$root.$bvToast.toast('Cadastro realizado com sucesso.', {
                                title: 'Cadastro realizado',
                                variant: 'success',
                                solid: true
                            });
                        }
                        this.$router.push('/home');
                    }).catch((err) => {
                        if(err.response){
                            this.$bvToast.toast(err.response.data.message, {
                            title: 'Erro ao cadastrar',
                            variant: 'danger',
                            solid: true
                            });
                        }
                    });
            },

            headers() {
                const token = this.$store.getters['auth/token'].token
                const headers = { headers: { Authorization: 'Bearer ' + token }}
                return headers;
            },

            unmask(maskedCnpj) {
                const unmaskedCnpj = maskedCnpj.replace(/[^\w\s]/gi, "");
                return unmaskedCnpj;
            },

            formatMoney(ref) {
                var value = this[ref];
                value = value + '';
                value = parseInt(value.replace(/[\D]+/g, ''));
                value = value + '';
                value = value.replace(/([0-9]{2})$/g, ",$1");

                this[ref] = value;
                if(value == 'NaN') this[ref] = '';
            }
        }
    }
</script>
